import React from "react";
import styles from "./Bio.module.css";
import logoImg from "../assets/logo.png";

function Bio(props) {
  return (
    <div
      className={`
      ${styles.Bio}
      ${props.className || ""}
    `}
    >
      <img src={logoImg} alt="VoiceTyping logo" className={styles.logo} />
      <div className={styles.copy}>
        <strong>Built for fast, accessible writing on the web</strong>
        <p>
          VoiceTyping turns natural speech into clean text inside docs, email,
          chats, support tools, and everyday browser workflows.
        </p>
      </div>
    </div>
  );
}

export default Bio;
